module.exports = __webpack_public_path__ + "img/gift2.1c7dff08.png";